import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Mail, MessageSquare, Trash2, CheckCircle, ArrowLeft, Info } from 'lucide-react';
import './ZiroDeleteAccountPage.css';

const ZiroDeleteAccountPage = () => {
    const [formData, setFormData] = useState({
        userId: '',
        email: '',
        purpose: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    React.useEffect(() => {
        document.title = "Delete Account - Ziro";
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        // Simulate API call
        setTimeout(() => {
            setIsLoading(false);
            setIsSubmitted(true);
        }, 1500);
    };

    return (
        <div className="ziro-delete-container">
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="ziro-delete-card"
            >
                <AnimatePresence mode='wait'>
                    {!isSubmitted ? (
                        <motion.div 
                            key="form"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0, x: -20 }}
                        >
                            <div className="ziro-delete-header">
                                <div className="ziro-logo-placeholder">
                                    <Trash2 size={40} color="white" />
                                </div>
                                <h1 className="ziro-delete-title">Ziro Account Deletion</h1>
                                <p className="ziro-delete-subtitle">Ziro: HD video calls and chats</p>
                            </div>

                            <form className="ziro-form" onSubmit={handleSubmit}>
                                <div className="ziro-input-group">
                                    <label className="ziro-label"><User size={14} style={{display: 'inline', marginRight: '4px'}}/> User ID</label>
                                    <input 
                                        type="text" 
                                        name="userId"
                                        className="ziro-input" 
                                        placeholder="e.g. ziro_user_123"
                                        required 
                                        value={formData.userId}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="ziro-input-group">
                                    <label className="ziro-label"><Mail size={14} style={{display: 'inline', marginRight: '4px'}}/> Email Address</label>
                                    <input 
                                        type="email" 
                                        name="email"
                                        className="ziro-input" 
                                        placeholder="your@email.com"
                                        required 
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="ziro-input-group">
                                    <label className="ziro-label"><MessageSquare size={14} style={{display: 'inline', marginRight: '4px'}}/> Purpose of deletion</label>
                                    <textarea 
                                        name="purpose"
                                        className="ziro-input ziro-textarea" 
                                        placeholder="Tell us why you're leaving..."
                                        required
                                        value={formData.purpose}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                <button type="submit" className="ziro-delete-btn" disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        <>Delete my data!!</>
                                    )}
                                </button>
                            </form>
                            
                            <p style={{ marginTop: '2rem', fontSize: '0.8rem', color: '#64748b', textAlign: 'center' }}>
                                This action is permanent and cannot be undone.
                            </p>
                        </motion.div>
                    ) : (
                        <motion.div 
                            key="success"
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            className="ziro-success-container"
                        >
                            <div className="ziro-success-icon">
                                <CheckCircle size={40} />
                            </div>
                            <h2 className="ziro-success-title">Request Received</h2>
                            <p className="ziro-success-msg">
                                Your account for <strong>Ziro: HD video calls and chats</strong> is scheduled for removal. 
                                <br /><br />
                                <span style={{ color: '#ef4444', fontWeight: 'bold' }}>Your data will be deleted within 7 days.</span>
                                <br />
                                Your data will be deleted soon! We are processing your request immediately.
                            </p>

                            <div className="ziro-instructions">
                                <div className="ziro-instructions-title">
                                    <Info size={14} style={{display: 'inline', marginRight: '4px'}}/> Important Instructions
                                </div>
                                <ul className="ziro-instructions-list">
                                    <li>All your chat history will be permanently wiped.</li>
                                    <li>Your profile and contact associations will be removed.</li>
                                    <li>Any active subscriptions will be cancelled.</li>
                                    <li>Ensure you have backed up any vital communications.</li>
                                </ul>
                            </div>

                            <motion.button 
                                whileHover={{ x: -5 }}
                                className="ziro-delete-btn" 
                                style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.1)', marginTop: '2.5rem' }}
                                onClick={() => window.location.href = '/'}
                            >
                                <ArrowLeft size={18} /> Back to Home
                            </motion.button>
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.div>
        </div>
    );
};

export default ZiroDeleteAccountPage;
